import React, { useEffect, useState } from "react";
import { ProjectColors } from "../../../../interfaces/projects";
import { convertirNumeroArgentina } from "../../../../services/utils";
import { Lightbox } from "../../Lightbox";
import Pagination from "../../Pagination";
import "./projectsSearchPropertiesList.scss";

interface ProjectSearchPropertiesListProps {
  properties: any;
  colors: ProjectColors;
}

const ProjectSearchPropertiesList: React.FC<
  ProjectSearchPropertiesListProps
> = ({ properties, colors }) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [propertiesPerPage] = useState<number>(6);
  const [currentProperties, setCurrentProperties] = useState([]);

  useEffect(() => {
    calculatePagination(1);
  }, [properties]);

  const calculatePagination = (pageNumber: number): void => {
    const indexOfLastProperty = pageNumber * propertiesPerPage;
    const indexOfFirstProperty = indexOfLastProperty - propertiesPerPage;
    setCurrentProperties(
      properties
        .slice(indexOfFirstProperty, indexOfLastProperty)
        .sort((a, b) => a.order - b.order)
    );
  };

  const paginate = (pageNumber: number): void => {
    setCurrentPage(pageNumber);
    calculatePagination(pageNumber);
  };

  return (
    <div
      className="properties-list-container"
      style={{
        borderColor: colors.secondary,
      }}
    >
      <div className="properties-list">
        {currentProperties.map((property, i: number) => {
          return (
            <div
              key={i}
              className={`property ${property.disponible ? "" : "disabled"} ${
                property.lastUnity ? "last-unity" : ""
              }`}
              style={{
                color: property.disponible ? colors.secondary : "#a9a9a9",
              }}
            >
              <div className="img-wraper">
                <Lightbox src={property.image} alt={property.number} />
              </div>
              <div className="number font-bold">{property.number}</div>

              <ul
                style={{
                  color: property.disponible ? colors.primary : "inherit",
                }}
              >
                {property.torre && (
                  <li>
                    <b>TORRE {property.torre}</b>
                  </li>
                )}
                {property.ambientes && (
                  <li>
                    <b>Cantidad de Ambientes: </b>
                    {property.ambientes}
                  </li>
                )}
                {property.orientacion && (
                  <li>
                    <b>Orientación: </b>
                    {property.orientacion}
                  </li>
                )}
                {property.superficie && (
                  <li>
                    <b>Superficie: </b>
                    {convertirNumeroArgentina(property.superficie)} mt²
                  </li>
                )}
                {property.exterior && (
                  <li>
                    <b>{property.exterior}</b>
                  </li>
                )}
              </ul>
            </div>
          );
        })}
      </div>

      <Pagination
        currentPage={currentPage}
        paginate={paginate}
        postsPerPage={propertiesPerPage}
        totalPosts={properties.length}
        colors={colors}
      />
    </div>
  );
};

export default ProjectSearchPropertiesList;
